import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-times",
  "use": "icon-times-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-times\"><path d=\"M1 1l17.678 17.678m0-17.678L1 18.678\" fill=\"none\" stroke-linecap=\"square\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol